














 





















const node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "meetingId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "meetingId",
    "variableName": "meetingId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "queryString",
  "storageKey": null
},
v5 = [
  {
    "kind": "Variable",
    "name": "teamId",
    "variableName": "teamId"
  }
],
v6 = [
  {
    "kind": "Literal",
    "name": "maxRepositories",
    "value": 100
  }
],
v7 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "occurredAt",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "_xGitHubRepository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameWithOwner",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "GitHubScopingSearchFilterMenuQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "meeting",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GitHubSearchQuery",
                        "kind": "LinkedField",
                        "name": "githubSearchQuery",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "type": "PokerMeeting",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "TeamMember",
            "kind": "LinkedField",
            "name": "teamMember",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "GitHubRepoSearchFilterMenu_teamMember"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "GitHubScopingSearchFilterMenuQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "meeting",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GitHubSearchQuery",
                        "kind": "LinkedField",
                        "name": "githubSearchQuery",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "type": "PokerMeeting",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "TeamMember",
            "kind": "LinkedField",
            "name": "teamMember",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamMemberIntegrations",
                "kind": "LinkedField",
                "name": "integrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GitHubIntegration",
                    "kind": "LinkedField",
                    "name": "github",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "_xGitHubApi",
                        "kind": "LinkedField",
                        "name": "api",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "_xGitHubQuery",
                            "kind": "LinkedField",
                            "name": "query",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "_xGitHubUser",
                                "kind": "LinkedField",
                                "name": "viewer",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "_xGitHubContributionsCollection",
                                    "kind": "LinkedField",
                                    "name": "contributionsCollection",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": (v6/*: any*/),
                                        "concreteType": "_xGitHubCommitContributionsByRepository",
                                        "kind": "LinkedField",
                                        "name": "commitContributionsByRepository",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": [
                                              (v7/*: any*/),
                                              {
                                                "kind": "Literal",
                                                "name": "orderBy",
                                                "value": {
                                                  "direction": "DESC",
                                                  "field": "OCCURRED_AT"
                                                }
                                              }
                                            ],
                                            "concreteType": "_xGitHubCreatedCommitContributionConnection",
                                            "kind": "LinkedField",
                                            "name": "contributions",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "_xGitHubCreatedCommitContribution",
                                                "kind": "LinkedField",
                                                "name": "nodes",
                                                "plural": true,
                                                "selections": [
                                                  (v8/*: any*/),
                                                  (v9/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": "contributions(first:1,orderBy:{\"direction\":\"DESC\",\"field\":\"OCCURRED_AT\"})"
                                          }
                                        ],
                                        "storageKey": "commitContributionsByRepository(maxRepositories:100)"
                                      },
                                      {
                                        "alias": null,
                                        "args": (v6/*: any*/),
                                        "concreteType": "_xGitHubIssueContributionsByRepository",
                                        "kind": "LinkedField",
                                        "name": "issueContributionsByRepository",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": [
                                              (v7/*: any*/),
                                              {
                                                "kind": "Literal",
                                                "name": "orderBy",
                                                "value": {
                                                  "direction": "DESC"
                                                }
                                              }
                                            ],
                                            "concreteType": "_xGitHubCreatedIssueContributionConnection",
                                            "kind": "LinkedField",
                                            "name": "contributions",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "_xGitHubCreatedIssueContributionEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "_xGitHubCreatedIssueContribution",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v8/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": "contributions(first:1,orderBy:{\"direction\":\"DESC\"})"
                                          },
                                          (v9/*: any*/)
                                        ],
                                        "storageKey": "issueContributionsByRepository(maxRepositories:100)"
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v3/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "q_0JTD5e6N_9BMPPd1ncXQEg",
    "metadata": {},
    "name": "GitHubScopingSearchFilterMenuQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node ).hash = "1ce1597116e9e698a8179e0f946b7029";

export default node;
